import styles from './Text.module.scss.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { themeColorToCssVariable } from '../theme/util.js';
import { SkeletonText } from '../skeleton/SkeletonText.js';
import { UNSAFE_Icon } from '../icon/Icon.js';
import classNames from 'clsx';

const variantToElementMap = {
  'headline-1': 'h1',
  'headline-2': 'h2',
  'headline-3': 'h3',
  'headline-4': 'h4',
  'headline-5': 'h5',
  'headline-6': 'h6',
  'display-headline-1': 'h1',
  'display-headline-2': 'h2',
  'display-headline-3': 'h3',
  'display-headline-4': 'h4',
  'display-headline-5': 'h5',
  'display-headline-6': 'h6',
  'light-headline-1': 'h1',
  'light-headline-2': 'h2',
  'light-headline-3': 'h3',
  'light-headline-4': 'h4',
  'light-headline-5': 'h5',
  'light-headline-6': 'h5',
  code: 'code',
  'code-small': 'code'
};

/** Provides the className for the text variant. */
function getTextVariantClassName(variant) {
  return styles[variant];
}

/**
 * A text element with optional icon.
 */
function Text(props) {
  const {
    className: callerClassName,
    color,
    variant = 'body',
    element: Element = variantToElementMap[variant] ?? 'div',
    icon,
    iconPosition = 'start',
    iconColor,
    children,
    loadingState = 'initial',
    skeletonProps,
    tag,
    ...rest
  } = props;
  const className = classNames('dsx-component', styles['text'], styles[variant], callerClassName);
  const style = {
    color: themeColorToCssVariable(color)
  };
  let childEl = children;
  if (icon) {
    childEl = iconPosition === 'end' ? /*#__PURE__*/jsxs(Fragment, {
      children: [children, ' ', /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: icon,
        className: styles['icon-adjustment'],
        color: iconColor
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: icon,
        className: styles['icon-adjustment'],
        color: iconColor
      }), ' ', children]
    });
  }
  const isLoading = loadingState === 'loading';
  return isLoading ? /*#__PURE__*/jsx(SkeletonText, {
    className,
    tag,
    variant,
    ...skeletonProps
  }) : /*#__PURE__*/jsx(Element, {
    ...rest,
    className: className,
    style: style,
    "aria-live": "polite",
    "data-dsx--text": tag,
    children: childEl
  });
}

export { Text, getTextVariantClassName };
